import { render } from "./MW2023HomePage.vue?vue&type=template&id=5e15a604&scoped=true"
import script from "./MW2023HomePage.vue?vue&type=script&lang=js"
export * from "./MW2023HomePage.vue?vue&type=script&lang=js"

import "./MW2023HomePage.vue?vue&type=style&index=0&id=5e15a604&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e15a604"]])

export default __exports__